import { render, staticRenderFns } from "./Servicios.vue?vue&type=template&id=03f464ba&scoped=true&"
import script from "./Servicios.vue?vue&type=script&lang=ts&"
export * from "./Servicios.vue?vue&type=script&lang=ts&"
import style0 from "./Servicios.vue?vue&type=style&index=0&id=03f464ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f464ba",
  null
  
)

export default component.exports